import { Outlet, useLocation } from 'react-router-dom';
import RevenueBrandBar from '../components/RevenueBrandBar';
import './private-layout.scss';

/**
 * Shared frame for authenticated and transactional screens. Public navigation
 * intentionally never lives in this tree, so private pages cannot inherit the
 * marketing header or footer by accident.
 */
export default function PrivateLayout() {
  const { pathname } = useLocation();
  const showMasthead = pathname === '/login' || pathname === '/register';

  return (
    <div className="ntp-private-layout">
      {showMasthead && <RevenueBrandBar />}
      <Outlet />
    </div>
  );
}
